import React, { useEffect, useState } from 'react';
import { Checkbox, Tooltip } from 'antd';
import { InfoCircleFilled, FilterFilled } from '@ant-design/icons';
import SlidingFilter from './SlidingFilter';

const CheckboxGroup = Checkbox.Group;
const plainOptions = [
  { label: 'Disclosed Vendors', value: 'disclosed' },
  { label: 'Disclosed triggering Non-Disclosed', value: 'disclosed-triggering-non-disclosed' },
  { label: 'Non-Disclosed', value: 'non-disclosed' },
];
const allOptionsList = ['disclosed', 'disclosed-triggering-non-disclosed', 'non-disclosed'];

const VendorTraceNonDisclosedFilter = ({ onChangeDisclosed, defaultCheckedList }) => {
  const [checkedList, setCheckedList] = useState(defaultCheckedList);
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(true);

  useEffect(() => {
    if (checkedList.length === allOptionsList.length) {
      setCheckAll(true);
      setIndeterminate(false);
    } else {
      setCheckAll(false);
      if (checkedList.length > 0) {
        setIndeterminate(true);
      }
    }
  }, [checkedList]);

  const onChange = (list) => {
    onChangeDisclosed(list);
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < allOptionsList.length);
    setCheckAll(list.length === allOptionsList.length);
  };

  const onCheckAllChange = (e) => {
    onChangeDisclosed(e.target.checked ? allOptionsList : []);
    setCheckedList(e.target.checked ? allOptionsList : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  return (
    <SlidingFilter className={'vendor-trace-non-disclosed-filter'} type="left">
      <div className={'vendor-trace-non-disclosed-filter-container'}>
        <div className={'title-row'}>
          <FilterFilled />
          <div>Vendor Disclosure</div>
          <Tooltip
            overlayClassName="diagnose--tooltip vendor-trace-prevalence-filter-tooltip-overlay"
            title={() => {
              return (
                <div className={'tooltip-content'}>
                  <div>
                    Non disclosed Vendors Vendors highlighted in red are not disclosed in your vendor list. Those
                    highlighted in amber are disclosed on the vendor list but triggering vendors that aren't. Vendors
                    highlighted in green are disclosed on the vendor list
                  </div>
                </div>
              );
            }}
          >
            <InfoCircleFilled />
          </Tooltip>
        </div>
        <div className={'filter-block'}>
          <div className={'color-tags-container'}>
            <div className={'color-tag'} style={{ opacity: 0 }} />
            <div className={'color-tag'} style={{ backgroundColor: '#03A233' }} />
            <div className={'color-tag'} style={{ backgroundColor: '#FFC62B' }} />
            <div className={'color-tag'} style={{ backgroundColor: '#CC483B' }} />
          </div>
          <div className={'checkbox-list'}>
            <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>
              All
            </Checkbox>
            <CheckboxGroup options={plainOptions} value={checkedList} onChange={onChange} />
          </div>
        </div>
      </div>
    </SlidingFilter>
  );
};

export default VendorTraceNonDisclosedFilter;
